import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { ValuesGroup } from '../../model/values-group';

@Component({
  selector: 'app-select-with-delete-option',
  templateUrl: './select-with-delete-option.component.html',
  styleUrls: ['./select-with-delete-option.component.scss']
})
export class SelectWithDeleteOptionComponent<T> {

  @Input() groupedValues: ValuesGroup<T>[];
  @Input() valuesDescription: string;
  @Input() loadingFilters: boolean;
  @Output() valueSelected = new EventEmitter<T>();
  @Output() valueDeleted = new EventEmitter<T>();
  selectValueControl: FormControl;

  constructor() {
    this.selectValueControl = new FormControl(null);
  }

  onValueSelected(event: MatSelectChange): void {
    this.valueSelected.emit(event.value);
  }

  onDeleteValue(event: MouseEvent, value: T): void {
    event.stopPropagation();
    if (this.currentValue == value)
      this.selectValueControl.setValue(null);
    this.valueDeleted.emit(value);
  }

  selectValue(value: T): void {
    this.selectValueControl.setValue(value);
  }

  getMatOptGroupStyle(group: ValuesGroup<T>): string {
    return '--option-background-color:' + group.backgroundColor;
  }

  get currentValue(): T {
    return this.selectValueControl.value;
  }
}
